'use client';

import Script from 'next/script';

const HubspotScripts = () => {
  const hubspotId = process.env.NEXT_PUBLIC_HUBSPOT_INSTANCE_ID;
  const isEnabled =
    process.env.NEXT_PUBLIC_ENABLE_HUBSPOT_COOKIE_BANNER === 'true';

  if (!hubspotId) {
    return null;
  }

  return (
    <>
      <Script
        id="hs-script-loader"
        strategy="afterInteractive"
        src={`https://js.hs-scripts.com/${hubspotId}.js`}
      />
      {isEnabled && (
        <Script
          id={`cookieBanner-${hubspotId}`}
          strategy="afterInteractive"
          src={`https://js.hs-banner.com/v2/${hubspotId}/banner.js`}
          data-hsjs-env="preLive"
          data-hsjs-portal={hubspotId}
        />
      )}
    </>
  );
};

export default HubspotScripts;
